/* Ferseng — Varak theme scripts. No dependencies. */
(function () {
  'use strict';

  var F = window.Ferseng || { routes: {}, strings: {} };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Hero video in the rug ---------- */
  function initRugVideos() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;

    $$('[data-rug-video]').forEach(function (field) {
      var video = $('video', field);
      var toggle = $('[data-video-toggle]', field);
      if (!video) return;

      function setState(paused) {
        if (!toggle) return;
        toggle.classList.toggle('is-paused', paused);
        toggle.setAttribute('aria-label', paused ? F.strings.playVideo : F.strings.pauseVideo);
      }

      if (reduceMotion || saveData) {
        video.removeAttribute('autoplay');
        video.pause();
        setState(true);
      } else {
        var p = video.play();
        if (p && p.catch) p.catch(function () { setState(true); });
      }

      video.addEventListener('play', function () { setState(false); });
      video.addEventListener('pause', function () { setState(true); });

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) video.play(); else video.pause();
        });
      }

      // Pause when the hero scrolls out of view to save battery.
      if ('IntersectionObserver' in window) {
        var userPaused = false;
        if (toggle) toggle.addEventListener('click', function () { userPaused = video.paused; });
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) video.pause();
            else if (!userPaused && !reduceMotion && !saveData) video.play().catch(function () {});
          });
        }, { threshold: 0.15 }).observe(field);
      }
    });
  }

  /* ---------- Menu drawer ---------- */
  function initMenuDrawer() {
    var drawer = $('[data-menu-drawer]');
    if (!drawer) return;
    $$('[data-menu-close]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { drawer.removeAttribute('open'); $('summary', drawer).focus(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.hasAttribute('open')) { drawer.removeAttribute('open'); $('summary', drawer).focus(); }
    });
    drawer.addEventListener('toggle', function () {
      document.body.style.overflow = drawer.open ? 'hidden' : '';
    });
  }

  /* ---------- Search modal + predictive search ---------- */
  function initSearch() {
    var modal = $('[data-search-modal]');
    if (!modal || typeof modal.showModal !== 'function') return;
    var input = $('[data-predictive-input]', modal);
    var results = $('[data-predictive-results]', modal);
    var timer, controller;

    $$('[data-search-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); modal.showModal(); input.focus(); });
    });
    $$('[data-search-close]', modal).forEach(function (b) { b.addEventListener('click', function () { modal.close(); }); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = F.routes.root + 'search/suggest?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var block = doc.querySelector('[data-predictive]');
            results.innerHTML = block ? block.outerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------- Localization selectors ---------- */
  function initLocalization() {
    $$('[data-autosubmit]').forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
    });
  }

  /* ---------- Cart (drawer + Section Rendering API) ---------- */
  var Cart = {
    drawer: null,
    lastFocus: null,

    init: function () {
      this.drawer = $('[data-cart-drawer]');
      var self = this;
      document.addEventListener('click', function (e) {
        var open = e.target.closest('[data-cart-open]');
        if (open && self.drawer && !self.drawer.hasAttribute('data-cart-page-mode')) {
          e.preventDefault();
          self.open();
        }
        if (e.target.closest('[data-cart-close]')) self.close();
        var qtyBtn = e.target.closest('[data-qty-change]');
        if (qtyBtn) {
          var line = qtyBtn.closest('[data-line]');
          if (line) self.change(parseInt(line.getAttribute('data-line'), 10), parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.drawer && !self.drawer.hidden) self.close();
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      var panel = $('.cart-drawer__panel', this.drawer);
      if (panel) panel.focus();
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.hidden = true;
      document.body.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    },

    render: function (sections) {
      if (!sections) return;
      var html = sections['cart-drawer'];
      if (html && this.drawer) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh) {
          var wasOpen = !this.drawer.hidden;
          this.drawer.innerHTML = fresh.innerHTML;
          this.drawer.hidden = !wasOpen;
        }
      }
    },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    },

    change: function (line, quantity) {
      var self = this;
      if (self.drawer) self.drawer.classList.add('is-loading');
      fetch(F.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'] })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
          self.render(cart.sections);
          self.updateCount(cart.item_count);
        })
        .finally(function () { if (self.drawer) self.drawer.classList.remove('is-loading'); });
    },

    add: function (formData) {
      var self = this;
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
      return fetch(F.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || F.strings.addError);
          if (!self.drawer || self.drawer.hasAttribute('data-cart-page-mode')) {
            window.location.href = F.routes.cart;
            return;
          }
          self.render(res.data.sections);
          return fetch(F.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) {
            self.updateCount(cart.item_count);
            self.open();
          });
        });
    }
  };

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var form = $('[data-product-form]', root);
    var variantsEl = $('[data-variants]', root);
    if (!form || !variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var stickyAdd = $('[data-sticky-add]', root);
    var priceEl = $('[data-price]', root);
    var stickyPrice = $('[data-sticky-price]', root);
    var errorEl = $('[data-form-error]', form);
    var fieldsets = $$('fieldset[data-option-index]', form);
    var moneyFormat = null;

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        }).format(amount);
      } catch (e) { return amount; }
    }

    function markUnavailable() {
      var current = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = current.slice();
          test[idx] = input.value;
          var match = variants.find(function (v) {
            return v.available && v.options.every(function (o, i) { return test[i] === null || o === test[i]; });
          });
          input.classList.toggle('is-unavailable', !match);
        });
      });
    }

    function setButtons(variant) {
      var label, disabled;
      if (!variant) { label = F.strings.unavailable; disabled = true; }
      else if (!variant.available) { label = F.strings.soldOut; disabled = true; }
      else { label = F.strings.addToCart; disabled = false; }
      [addBtn, stickyAdd].forEach(function (b) {
        if (!b) return;
        b.disabled = disabled;
        b.textContent = label;
      });
    }

    // Let pre-order and other apps know the variant changed.
    function announceVariant(variant) {
      if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
      root.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: variant } }));
    }

    function onChange() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var label = $('[data-option-label]', fs);
        if (label) label.textContent = opts[i] || '';
      });
      var variant = findVariant(opts);
      setButtons(variant);
      markUnavailable();
      if (!variant) return;
      idInput.value = variant.id;

      // Price: re-render from the section so currency formatting stays exact.
      var sectionId = root.getAttribute('data-section');
      fetch(window.location.pathname + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-price]');
          if (fresh && priceEl) priceEl.innerHTML = fresh.innerHTML;
          var freshSticky = doc.querySelector('[data-sticky-price]');
          if (freshSticky && stickyPrice) stickyPrice.innerHTML = freshSticky.innerHTML;
        })
        .catch(function () {
          if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        });

      if (variant.featured_media) showMedia(String(variant.featured_media.id));
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      announceVariant(variant);
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', onChange); });
    if (fieldsets.length) markUnavailable();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      // Keep any label an app set (for example "Pre-order") so it comes back after adding.
      var prevMain = addBtn ? addBtn.innerHTML : '';
      var prevSticky = stickyAdd ? stickyAdd.innerHTML : '';
      [addBtn, stickyAdd].forEach(function (b) { if (b) { b.disabled = true; b.textContent = F.strings.adding; } });
      Cart.add(new FormData(form))
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        })
        .finally(function () {
          var v = findVariant(selectedOptions()) || (fieldsets.length ? null : variants[0]);
          setButtons(v);
          if (v && v.available) {
            if (addBtn && prevMain) addBtn.innerHTML = prevMain;
            if (stickyAdd && prevSticky) stickyAdd.innerHTML = prevSticky;
          }
        });
    });

    // Media thumbnails
    function showMedia(id) {
      $$('.product__slide', root).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === id); });
      $$('[data-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
    }
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });

    // Rug / Folio / Weave views
    $$('[data-view]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-view');
        $$('[data-view]', root).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        $$('[data-view-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-view-panel') !== view; });
      });
    });

    // Size guide and other dialogs
    $$('[data-dialog-open]', root).forEach(function (b) {
      var dlg = document.getElementById(b.getAttribute('data-dialog-open'));
      if (!dlg || typeof dlg.showModal !== 'function') return;
      b.addEventListener('click', function () { dlg.showModal(); });
      $$('[data-dialog-close]', dlg).forEach(function (c) { c.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    });

    // Sticky add-to-cart (mobile) once the main button leaves the screen
    var sticky = $('[data-sticky-atc]', root);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var below = e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !e.isIntersecting && below);
        });
      }).observe(addBtn);
    }

    // 3D models / view in your room
    var models = $('[data-product-models]', root);
    if (models && window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([
        { name: 'shopify-xr', version: '1.0', onLoad: function (err) {
          if (err || !window.ShopifyXR) return;
          ShopifyXR.addModels(JSON.parse(models.textContent));
          ShopifyXR.setupXRElements();
        } },
        { name: 'model-viewer-ui', version: '1.0' }
      ]);
    }
  }

  /* ---------- Collection filters ---------- */
  function initFacets() {
    var form = $('[data-facets]');
    if (!form) return;
    var timer;
    form.addEventListener('change', function (e) {
      clearTimeout(timer);
      var delay = e.target.type === 'number' ? 600 : 0;
      timer = setTimeout(function () {
        var params = new URLSearchParams(new FormData(form));
        Array.from(params.keys()).forEach(function (k) {
          if (params.get(k) === '') params.delete(k);
        });
        window.location.search = params.toString();
      }, delay);
    });
    // Close other open facets when one opens
    $$('[data-facet]', form).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        $$('[data-facet]', form).forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-facet]')) $$('[data-facet][open]', form).forEach(function (d) { d.open = false; });
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.children.length) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRugVideos();
    initMenuDrawer();
    initSearch();
    initLocalization();
    Cart.init();
    $$('[data-product]').forEach(initProduct);
    initFacets();
    initRecommendations();
  });

  // Theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    initRugVideos();
    $$('[data-product]', e.target).forEach(initProduct);
    initRecommendations();
  });
})();
